import clsx from 'clsx';
import type { ButtonHTMLAttributes, Ref } from 'react';

import s from './Button.module.scss';

export type ButtonProps = {
  ref?: Ref<HTMLButtonElement>;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button = ({ type = 'button', className, ...props }: ButtonProps) => (
  <button type={type} className={clsx(s.button, className)} {...props} />
);

export default Button;
